import { RootState } from '@core/configureStore';
import { GoogleReview } from '@core/models';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { heroApiService } from '@services/.';
import { ExtraReducer, getSideEffectState } from '@utils/.';
import { setStartDate } from '../store';
import { ReviewReducerProps } from '../type';

export const fetchReviews = createAsyncThunk('review/fetchReviews', async (_, thunkApi) => {
  const {
    auth: { user },
  } = thunkApi.getState() as RootState;
  if (!user) throw new Error('No user found');
  let reviewInfo = undefined;
  let reviews: GoogleReview[] = [];
  let nextPageToken = undefined;
  while (true) {
    const result: any = await heroApiService.getGoogleReviewsByLocation(
      user.selected_location.location_id,
      40,
      nextPageToken,
      'updateTime'
    );
    reviewInfo = result;
    nextPageToken = result.nextPageToken;
    if (result?.reviews) {
      reviews = reviews.concat(result?.reviews);
    }
    if (result.nextPageToken === undefined) break;
  }
  thunkApi.dispatch(setStartDate(reviews[reviews.length - 1]?.createTime));
  reviewInfo.reviews = reviews;
  return reviewInfo;
});

const [fulfilled, pending, rejected] = getSideEffectState(fetchReviews);

export const fetchReviewsReducer = {
  [fulfilled]: (state, action) => {
    state.isLoading = false;
    state.reviewResponse = action.payload;
  },
  [rejected]: (state, action) => {
    state.isLoading = false;
    state.error = '';
    state.reviewResponse = { reviews: [], averageRating: 0, totalReviewCount: 0 };
  },
  [pending]: (state, action) => {
    state.isLoading = true;
  },
} as ExtraReducer<ReviewReducerProps>;
